import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import MainNavigation from "./MainNavigation";
import logo from "../../images/0. Nav/Toyota_Logo.svg";

const Navigation = (props) => {
  const [isTabMobWidth, setIsTabMobWidth] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [isMenuShowing, setIsMenuShowing] = useState(false);

  let resizeWindow = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    if (windowWidth < 1025) {
      setIsTabMobWidth(true);
    } else setIsTabMobWidth(false);
    resizeWindow();
    window.addEventListener("resize", resizeWindow);

    return () => window.removeEventListener("resize", resizeWindow);
  }, [windowWidth]);

  return (
    <>
      {isTabMobWidth ? (
        <div className={`handheld-nav ${isMenuShowing && "open"}`}>
          <div className="topbar">
            <Link to={"/"}>
              <img className="logo" src={logo} alt="Toyota VIS Homepage" />
            </Link>
            <div className="mob-menu-btn">
              <div id="toggle">
                <input
                  type="checkbox"
                  onClick={() => setIsMenuShowing(!isMenuShowing)}
                />
                <span></span>
              </div>
            </div>
          </div>
          <MainNavigation
            isMenuShowing={isMenuShowing}
            environment={props.environment}
            page={props.page}
          />
        </div>
      ) : (
        <div className="sidebar">
          <MainNavigation
            subMenuItemClick={(e) => this.subMenuItemClick(e)}
            environment={props.environment}
            page={props.page}
          />
        </div>
      )}
    </>
  );
};

export default Navigation;
